import { client } from '@gandi/app-runner/client';
import { routerConfigs } from '@gandi/redux-sharing';
import { cartMiddleware } from '@gandi/cart';

import routes from './src/routes';
import reducers from './src/reducers';

const middlewares = [cartMiddleware];

const globals = {
  /* eslint-disable no-undef, object-shorthand */
  __DEV__: __DEV__,
  __ENV__: __ENV__,
  __SERVER__: __SERVER__,
  __CLIENT__: __CLIENT__,
  /* eslint-enable no-undef */
};

/* eslint-disable array-callback-return */
Object.keys(globals).map(key => {
  global[key] = globals[key];
});
/* eslint-enable array-callback-return */

client({
  middlewares,
  routes,
  reducers,
  anonymousSupport: true,
  routerConfig: routerConfigs.client,
  globals,
});
